module.exports = __webpack_public_path__ + "img/ic-facebook.58529616.svg";